import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class DelinquentRoute extends Route {
  @service router;
  @service session;

  @service('state-manager-hybrids.heartbeat-state-manager-hybrid')
  heartbeatHybrid;

  model() {
    return this.session.currentUser.company;
  }

  activate(transition) {
    super.activate(...arguments);

    this.controllerFor('application').setProperties({
      simpleHeaderRightText: 'Logout',
      simpleHeaderRightAction: () => this.session.invalidate(),
    });

    trackPageViewFromTransition(this, transition, '/delinquent/');
  }

  @action
  willTransition(transition) {
    if (this.heartbeatHybrid.accountLocked && transition.to.name !== 'signout') {
      transition.abort();
    } else {
      return true;
    }
  }

  /**
   * @inheritDoc
   */
  setupController(controller) {
    super.setupController(...arguments);

    controller.loadOutstandingInvoices.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadOutstandingInvoices.cancelAll({ resetState: true });
    }
  }
}

export default DelinquentRoute;
